module.exports = __webpack_public_path__ + "static/media/logo.1397d6a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.svg
// module id = 3948
// module chunks = 0